import { User } from "../Interface/Index";
import apiClient from "./api-client.service";

class UserService {
  private APIBaseUrl: string = "";
  private static instance: UserService;

  constructor() {
    if (UserService.instance) {
      return UserService.instance;
    }
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
    UserService.instance = this;
  }

  // Function to fetch user data from the API and store the current user
  async fetchUser() {
    try {
      const response = await apiClient.get(`${this.APIBaseUrl}/users/me`);
      console.log("UserService: Fetched user data", response.data);
      return response.data;
    } catch (err) {
      console.error("UserService: Error while fetching user data", err);
      throw err;
    }
  }

  async updateUser(id: string, data: User) {
    try {
      const { _id, createdAt, updatedAt, ...rest } = data;

      const payload = rest.mobileNumber
        ? {
            ...rest,
            mobileNumber: rest.mobileNumber.replace(/\s/g, ""),
          }
        : rest;
      const response = await apiClient.put(
        `${this.APIBaseUrl}/users/${id}`,
        payload,
      );
      return response.data;
    } catch (err) {
      console.error("UserService: Error while updating user data", err);
      throw err;
    }
  }
}

export default UserService;
